// src/components/SellerRoute.js
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Container, Spinner, Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const SellerRoute = () => {
    const { user, loading } = useAuth();
    const { t } = useTranslation();

    if (loading) {
        return (
            <Container className="d-flex justify-content-center align-items-center" style={{ height: '80vh' }}>
                <div className="text-center">
                    <Spinner animation="border" variant="primary" />
                    <p className="mt-3">{t('common.loading')}</p>
                </div>
            </Container>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    if (!user.isSeller) {
        return (
            <Container className="py-5">
                <Alert variant="danger">
                    <Alert.Heading>{t('seller.accessDenied')}</Alert.Heading>
                    <p>{t('seller.sellerRightsRequired')}</p>
                </Alert>
            </Container>
        );
    }

    return <Outlet />;
};

export default SellerRoute;